<! --
/**
* SuiteCRM is a customer relationship management program developed by SalesAgility Ltd.
* Copyright (C) 2022 SalesAgility Ltd.
*
* This program is free software; you can redistribute it and/or modify it under
* the terms of the GNU Affero General Public License version 3 as published by the
* Free Software Foundation with the addition of the following permission added
* to Section 15 as permitted in Section 7(a): FOR ANY PART OF THE COVERED WORK
* IN WHICH THE COPYRIGHT IS OWNED BY SALESAGILITY, SALESAGILITY DISCLAIMS THE
* WARRANTY OF NON INFRINGEMENT OF THIRD PARTY RIGHTS.
*
* This program is distributed in the hope that it will be useful, but WITHOUT
* ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
* FOR A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
* details.
*
* You should have received a copy of the GNU Affero General Public License
* along with this program.  If not, see http://www.gnu.org/licenses.
*
* In accordance with Section 7(b) of the GNU Affero General Public License
* version 3, these Appropriate Legal Notices must retain the display of the
* "Supercharged by SuiteCRM" logo. If the display of the logos is not reasonably
* feasible for technical reasons, the Appropriate Legal Notices must display
* the words "Supercharged by SuiteCRM".
*/
-->
<div class="logged-out-view full-height-view d-flex flex-column align-items-center justify-content-center">

    <div class="logo-row full-height-view-row">
        <scrm-logo-ui></scrm-logo-ui>
    </div>
    <div class="mt-3 mb-1 page-title full-height-view-row">
        <h2>
            <scrm-label labelKey="LBL_LOGGED_OUT_MESSAGE"></scrm-label>
        </h2>
    </div>
    <div class="page-subtitle full-height-view-row">
        <h5>
            <scrm-label labelKey="LBL_LOGIN_AGAIN"></scrm-label><a class="text-lowercase" [href]="getLoginURL()"><scrm-label labelKey="LBL_CLICK_HERE"></scrm-label></a>
        </h5>
    </div>
</div>
